import { Box, Button, ButtonAppearance, Heading, Modal, ModalBody, Spinner } from '@bechtel/gds';
import { ModalCloseStyled, ModalFooterStyled, ModalHeaderStyled } from '~/styles';

interface ConfirmDialogProps {
  onCancel: () => void;
  onConfirm?: () => void;
  title: string;
  message: string;
  cancelText?: string;
  confirmText?: string;
  onClose?: any;
  loading?: boolean;
}

export function ConfirmDialog({
  title,
  onConfirm,
  onCancel,
  cancelText = 'Cancel',
  confirmText = 'Confirm',
  message,
  onClose = false,
  loading,
}: ConfirmDialogProps) {
  return (
    <Modal visible={true} style={{ width: '532px', minHeight: '300px' }}>
      <ModalHeaderStyled title={title}>
        <ModalCloseStyled onClick={onClose ? onClose : onCancel}></ModalCloseStyled>
      </ModalHeaderStyled>
      <ModalBody>
        <Box p={{ sm: '500' }}>
          <Heading> {message}</Heading>
        </Box>
      </ModalBody>
      <ModalFooterStyled>
        <Box justifyContent={{ sm: 'flex-end' }} gap={{ sm: '500' }}>
          {onCancel && (
            <Box mr={{ sm: '400' }}>
              <Button disabled={loading} appearance={ButtonAppearance.SECONDARY} onClick={onCancel}>
                {cancelText}
              </Button>
            </Box>
          )}
          {onConfirm && (
            <Box>
              <Button css={{ minWidth: '100px' }} disabled={loading} onClick={onConfirm}>
                {loading ? <Spinner /> : confirmText}
              </Button>
            </Box>
          )}
        </Box>
      </ModalFooterStyled>
    </Modal>
  );
}
